<script>
export default {
  name: "aiModal",
  data() {
    return {
      lmList: [],
      cmList: [],
      dialogVisible: false,
      inputVal: '',
      instantAnswer:{
        content: null,
        question:null
      },
      isLoading: false,
    }
  },
  mounted() {
    this.getDashScopeLogList(0)
    this.getDashScopeLogList(1)
    setInterval(() => {
      this.getDashScopeLogList(0)
      this.getDashScopeLogList(1)
    },600000)
  },
  methods: {
    getDashScopeLogList(type) {
      this.$api.device.getDashScopeLogList(type).then(res => {
        if (res.code === 200) {
          if (type === 0) {
            this.lmList = res.data
          } else if (type === 1) {
            this.cmList = res.data
          }
        }
      })
    },
    getAIInstantAnswer() {
      if(this.inputVal){
        this.isLoading = true
        this.instantAnswer.question = this.inputVal
        this.$api.device.getAIInstantAnswer(this.inputVal).then(res => {
          if (res.code === 200) {
            this.instantAnswer.content = res.data
          }
        }).finally(() => {
          this.isLoading = false
        })
      }

    }
  }
}
</script>

<template>
  <div class="aiPage">
    <div class="titleBox">
      <img class="titleImg" src="../../assets/ai/title.png" alt=""/>
      <div class="titleBtn" @click="dialogVisible = true">
        <img src="../../assets/ai/question.png" alt=""/>
        <span>AI即时问答</span>
      </div>
    </div>
    <div class="contentBox">
      <div class="cmBox">
        <div class="cmTitle">
          <img class="cmTitleImg" src="../../assets/ai/cm.png" alt=""/>
          <p class="cmTitleText">草莓大棚</p>
        </div>
        <div class="list">
          <div v-for="item in cmList" :key="item.id" class="item">
            <p class="updateTime">{{item.updateTime}}</p>
            <div class="listTitle">
              <img src="../../assets/ai/sr.png" alt=""/>
              <p>AI模型输入</p>
            </div>
            <p class="question">{{ item.question }}</p>
            <div class="listTitle">
              <img src="../../assets/ai/sc.png" alt=""/>
              <p>AI模型输出</p>
            </div>
            <p class="answer">{{ item.content }}</p>
            <div v-if="item.executionFeedback" class="listTitle">
              <img src="../../assets/ai/fk.png" alt=""/>
              <p>执行反馈</p>
            </div>
            <el-tag style="white-space: pre-line" v-if="item.executionFeedback">{{ item.executionFeedback }}</el-tag>
          </div>
        </div>
      </div>
      <div class="lmBox">
        <div class="lmTitle">
          <img class="lmTitleImg" src="../../assets/ai/lm.png" alt=""/>
          <p class="lmTitleText">蓝莓大棚</p>
        </div>
        <div class="list">
          <div v-for="item in lmList" :key="item.id" class="item">
            <p class="updateTime">{{item.updateTime}}</p>
            <div class="listTitle">
              <img src="../../assets/ai/sr.png" alt=""/>
              <p>AI模型输入</p>
            </div>
            <p class="question">{{ item.question }}</p>
            <div class="listTitle">
              <img src="../../assets/ai/sc.png" alt=""/>
              <p>AI模型输出</p>
            </div>
            <p class="answer">{{ item.content }}</p>
            <div v-if="item.executionFeedback" class="listTitle">
              <img src="../../assets/ai/fk.png" alt=""/>
              <p>执行反馈</p>
            </div>
            <el-tag style="white-space: pre-line" v-if="item.executionFeedback">{{ item.executionFeedback }}</el-tag>
          </div>
        </div>
      </div>
    </div>
    <el-dialog custom-class="aiDialog" :visible.sync="dialogVisible" width="70%">
      <div>
        <img src="../../assets/ai/aiQue.png" alt="">
      </div>
      <div class="aiContainer" v-if="instantAnswer.question">
        <div class="listTitle">
          <img src="../../assets/ai/sr.png" alt=""/>
          <p>AI模型输入</p>
        </div>
        <p class="question">{{ instantAnswer.question }}</p>
        <div class="listTitle">
          <img src="../../assets/ai/sc.png" alt=""/>
          <p>AI模型输出</p>
        </div>

        <div class="answer">
          <div v-if="isLoading" class="loading-dots">
            <span></span>
            <span></span>
            <span></span>
          </div>
          <span v-else>{{ instantAnswer.content }}</span>
        </div>
      </div>
      <div class="aiInputBox">
        <el-input
            type="textarea"
            class="aiInput"
            :autosize="{ minRows: 3, maxRows: 8}"
            v-model="inputVal"
            placeholder="请输入您的问题描述…">
        </el-input>
        <img @click="getAIInstantAnswer" class="send" src="../../assets/ai/send.png" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<style scoped lang="scss">
.aiPage {
  background: #D0E7FF;

  .titleBox {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    padding: 16px 16px 0;

    .titleImg {
      width: 268px;
      height: 64px;
    }

    .titleBtn {
      position: absolute;
      bottom: 0;
      right: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #FFFFFF;
      width: 158px;
      height: 42px;
      background: linear-gradient(175deg, #14DDEB 0%, #42A8FB 100%);
      box-shadow: 0px 2px 4px 0px rgba(66, 168, 251, 0.38);
      border-radius: 21px;
      cursor: pointer;
    }
  }

  .contentBox {
    display: flex;
    margin-top: 16px;

    .cmBox {
      width: calc(50% - 72.5px);
      margin-left: 52px;
      background: #FFFFFF;
      border-radius: 34px;

      .cmTitle {
        border-top-left-radius: 34px;
        border-top-right-radius: 34px;
        background: linear-gradient(176deg, #FF805A 0%, #FF5B59 100%);
        height: 59px;
        position: relative;
        display: flex;
        align-items: center;

        .cmTitleImg {
          position: absolute;
          left: 10px;
          top: -20px;
        }

        .cmTitleText {
          margin-left: 80px;
          color: #FFFFFF;
          font-weight: bold;
          font-size: 20px;
        }
      }
    }

    .lmBox {
      width: calc(50% - 72.5px);
      margin-left: 41px;
      background: #FFFFFF;
      border-radius: 34px;

      .lmTitle {
        border-top-left-radius: 34px;
        border-top-right-radius: 34px;
        background: linear-gradient(111deg, #266AFB 0%, #3A85FE 100%);
        height: 59px;
        position: relative;
        display: flex;
        align-items: center;

        .lmTitleImg {
          position: absolute;
          left: 10px;
          top: -20px;
        }

        .lmTitleText {
          margin-left: 100px;
          color: #FFFFFF;
          font-weight: bold;
          font-size: 20px;
        }
      }
    }
  }

  .list {
    padding: 16px;
    ::v-deep .el-tag {
      height: auto;
      width: 100%;
      white-space: normal;
    }
    .updateTime {
      color: #333333;
      font-size: 14px;
    }
    .item{
      border-bottom: 1px solid #EEEEEE;
      padding: 8px 0 16px;
    }
  }
  .listTitle {
    display: flex;
    align-items: center;
    width: 180px;
    height: 28px;
    margin: 12px 0;
    background: linear-gradient(270deg, rgba(255, 255, 255, 0) 0%, rgba(28, 136, 228, 0.21) 100%);
    border-radius: 14px;

    p {
      margin-left: 5px;
      font-weight: bold;
      color: #0d1315;
    }
  }

  .question {
    background: #F2F2F2;
    border-radius: 8px;
    padding: 15px;
    color: #333333;
    white-space: pre-line;
  }

  .answer {
    background: #F2F2F2;
    border-radius: 8px;
    padding: 15px;
    color: #333333;
    white-space: pre-line;
  }
  ::v-deep .aiDialog{
    border-radius: 16px;
    .el-dialog__body{
      padding: 0 20px 30px;
    }
    .aiContainer{
      padding: 30px 0 10px;
    }
    .aiInputBox{
      position: relative;
      padding-top: 16px;
      .aiInput{
        .el-textarea__inner{
          padding-right: 40px;
        }
      }
      .send{
        position: absolute;
        right: 10px;
        top: 50%;
        margin-top: -15px;
        z-index: 10;
        cursor: pointer;
      }
    }
    .loading-dots {
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 4px; /* 控制点之间的间距 */
      width: 25px;
    }

    .loading-dots span {
      display: inline-block;
      width: 8px;
      height: 8px;
      border-radius: 50%;
      background-color: #999; /* 点的颜色 */
      animation: bounce 1.4s ease-in-out infinite both;
    }

    .loading-dots span:nth-child(1) {
      animation-delay: -0.32s;
    }

    .loading-dots span:nth-child(2) {
      animation-delay: -0.16s;
    }

    @keyframes bounce {
      0%, 80%, 100% {
        transform: translateY(0);
      }
      40% {
        transform: translateY(-10px); /* 跳起高度 */
      }
    }

  }
}
</style>